<template>
    <div id="group-card">
        <v-breadcrumbs :items="routes" divider="|"></v-breadcrumbs>

        <h1 class="page-header mt-5">Dashboard</h1>

        <div class="dashboard-container mt-6">
            <iframe
                width="100%"
                height="675"
                :src="lookerStudioUrl"
                frameborder="0"
                style="border: 0"
                allowfullscreen
                sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            ></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: "home",

    data: () => ({
        routes: [
            {
                text: "Home",
                disabled: true,
                href: "breadcrumbs_dashboard",
            },
            {
                text: "Dashboard",
                disabled: false,
                href: "/admin",
            },
        ],
        lookerStudioUrl:
            "https://lookerstudio.google.com/embed/reporting/97bdda90-781e-460f-b74e-01480d50d058/page/hnooF",
    }),

    beforeCreate: function () {
        if (!this.$store.state.auth.loggedIn) {
            this.$router.push("/login");
        }
    },
};
</script>

<style scoped>
.v-breadcrumbs__item {
    font-family: roboto;
}

.dashboard-container {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

iframe {
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// Home.vue?6725a7e5